/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import type { Middleware } from '@reduxjs/toolkit'
import type { RootState } from 'store/reducer'
import type { GetProfileResponse } from 'store/users/types'

import { actions } from 'store/users'
import tracker from 'tracker'
import { removeAccessToken } from 'utils/access-token'

export const trackerIdentifyUserMiddleware: Middleware<unknown, RootState> =
  (_) => (next) => (action) => {
    if (action.type === actions.getUserProfile.fulfilled.type) {
      const actionPayload = action.payload as unknown as GetProfileResponse
      tracker?.identifyUser(actionPayload.result || {})
    }
    if (action.type === actions.getUserProfile.rejected.type) {
      removeAccessToken()
    }
    return next(action)
  }
